/* Maison Thaevia — New Arrivals carousel
   Scroll-snap track with prev/next arrows and a bronze progress bar.
   Auto-advances every 3.6s (same cadence as CollectionsIndex), pauses
   on hover, and loops back to the first card from the end. */

if (!customElements.get('mt-arrivals-carousel')) {
  class MTArrivalsCarousel extends HTMLElement {
    connectedCallback() {
      this._track    = this.querySelector('.mt-arrivals__track');
      this._prev     = this.querySelector('.mt-arrivals__arrow--prev');
      this._next     = this.querySelector('.mt-arrivals__arrow--next');
      this._bar      = this.querySelector('.mt-arrivals__indicator');
      this._hovering = false;

      if (!this._track) return;

      this._prev?.addEventListener('click', () => this._scroll(-1));
      this._next?.addEventListener('click', () => this._scroll(1));
      this._track.addEventListener('scroll', () => this._update(), { passive: true });

      /* Pause auto-drift while the user's pointer is over the section */
      this.addEventListener('mouseenter', () => { this._hovering = true; });
      this.addEventListener('mouseleave', () => { this._hovering = false; });

      /* Auto-advance every 3.6s — mirrors CollectionsIndex idle cadence */
      this._drift = setInterval(() => {
        if (this._hovering) return;
        const t   = this._track;
        const max = t.scrollWidth - t.clientWidth;
        if (t.scrollLeft >= max - 2) {
          t.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this._scroll(1);
        }
      }, 3600);

      /* Set initial arrow + bar state after layout */
      requestAnimationFrame(() => this._update());
    }

    _cardStep() {
      const first = this._track.firstElementChild;
      if (!first) return 280;
      const style = getComputedStyle(this._track);
      const gap   = parseFloat(style.columnGap) || 20;
      return first.getBoundingClientRect().width + gap;
    }

    _scroll(dir) {
      this._track.scrollBy({ left: dir * this._cardStep(), behavior: 'smooth' });
    }

    _update() {
      const t   = this._track;
      const sl  = t.scrollLeft;
      const max = t.scrollWidth - t.clientWidth;

      if (this._prev) this._prev.disabled = sl <= 2;
      if (this._next) this._next.disabled = sl >= max - 2;

      if (this._bar && max > 0) {
        const pct = sl / max;
        /* Indicator travels from 0% to 70% of the bar */
        this._bar.style.left = `${Math.round(pct * 70)}%`;
      }
    }

    disconnectedCallback() {
      clearInterval(this._drift);
    }
  }

  customElements.define('mt-arrivals-carousel', MTArrivalsCarousel);
}
